"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const axios_1 = __importDefault(require("axios"));
class BulkActionsService {
    constructor() {
        this.isLoadingBulkAction = false;
        this.actionCompleted = false;
    }
    async accessSamples(samplesIds, distributorsIds, grant) {
        const url = '/biomemakers-access/grant_revoke_sample_access';
        this.actionCompleted = false;
        this.isLoadingBulkAction = true;
        try {
            await axios_1.default.post(url, {
                distributors: distributorsIds,
                samples: samplesIds,
                flag_grant: grant,
            });
            this.isLoadingBulkAction = false;
        }
        catch (error) {
            console.log(error);
        }
        this.actionCompleted = true;
    }
    async accessProjects(projectsIds, distributorsIds, grant) {
        const url = '/biomemakers-access/grant_revoke_project_access';
        this.actionCompleted = false;
        this.isLoadingBulkAction = true;
        try {
            await axios_1.default.post(url, {
                distributors: distributorsIds,
                projects: projectsIds,
                flag_grant: grant,
            });
            this.isLoadingBulkAction = false;
        }
        catch (error) {
            console.log(error);
        }
        this.actionCompleted = true;
    }
}
exports.default = BulkActionsService;
